module.exports = __webpack_public_path__ + "img/dataInsightsLoginImg.5e11fab8.svg";